import { render, staticRenderFns } from "./Crmlist.vue?vue&type=template&id=0fb9362e&scoped=true"
import script from "./Crmlist.vue?vue&type=script&lang=js"
export * from "./Crmlist.vue?vue&type=script&lang=js"
import style0 from "./Crmlist.vue?vue&type=style&index=0&id=0fb9362e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb9362e",
  null
  
)

export default component.exports